
import { defineComponent, ref, Ref } from "vue";
import {
  IonContent,
  IonPage,
  IonButtons,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonBackButton,
  IonFooter,
  IonButton,
} from "@ionic/vue";
import StoryComponent from "@/components/StoryComponent.vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "@/store";
import Storage from "@aws-amplify/storage";
import Auth from "@aws-amplify/auth";
import API from "@aws-amplify/api";

export default defineComponent({
  components: {
    IonContent,
    IonPage,
    IonHeader,
    IonButtons,
    IonToolbar,
    StoryComponent,
    IonBackButton,
    IonTitle,
    IonFooter,
    IonButton,
  },
  name: "MarketPlaceDetails",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const storyId = route.params.id;
    const store = useStore();
    const story = store.state.stories.find((story) => story.id == storyId);
    const buyGame = function () {
      const gameId = Date.now();
      const game = {
        id: gameId,
        moderator: "me",
        story: 1,
        round: 0,
      };
      Auth.currentCredentials().then((user) => {
        const identityId = user.identityId; // data is stored in folder protected/identityId/
        Storage.put(`${gameId}.json`, JSON.stringify(game), {
          contentType: "text/json",
        })
          .then((result) => {
            console.log(`uploaded file to ${result}`);
            
          })
          .catch((error) => console.log(error));
        router.push("/dates");
      });
    };
    return { story, buyGame };
  },
});
